module.exports = __webpack_public_path__ + "img/shop7-8.942d9aa5.png";